import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { products } from '../mockData';

const ProductCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 4;
  const maxIndex = Math.max(0, products.length - itemsPerView);

  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prev => Math.min(maxIndex, prev + 1));
  };

  return (
    <section id="collection" className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div style={{ marginBottom: '48px', textAlign: 'center' }}>
          <h2 className="hero-medium" style={{ marginBottom: '16px' }}>The Collection</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Discover our curated selection of handcrafted footwear
          </p>
        </div>

        <div style={{ position: 'relative' }}>
          <div style={{ overflow: 'hidden' }}>
            <div 
              style={{ 
                display: 'flex',
                transition: 'transform 0.5s ease-in-out',
                transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`
              }}
            >
              {products.map(product => (
                <div 
                  key={product.id} 
                  style={{ 
                    flex: `0 0 ${100 / itemsPerView}%`,
                    padding: '0 16px'
                  }}
                >
                  <div className="product-card">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="product-card-image"
                    />
                    <h3 className="product-card-title">{product.name}</h3>
                    <p className="product-card-description">{product.description}</p>
                    <p className="product-card-title" style={{ marginTop: '12px' }}>{product.price}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <button 
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="btn-icon"
            style={{ 
              position: 'absolute',
              left: '-40px',
              top: '50%',
              transform: 'translateY(-50%)',
              opacity: currentIndex === 0 ? 0.3 : 1
            }}
            aria-label="Previous"
          >
            <ChevronLeft size={24} />
          </button>

          <button 
            onClick={handleNext}
            disabled={currentIndex >= maxIndex}
            className="btn-icon"
            style={{ 
              position: 'absolute',
              right: '-40px',
              top: '50%',
              transform: 'translateY(-50%)',
              opacity: currentIndex >= maxIndex ? 0.3 : 1
            }}
            aria-label="Next"
          >
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProductCarousel;
